import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"

export const AdminUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const { groups, username } = useAppSelector(selectUserInfo)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!username) navigate("/login", { replace: true })
    else if (!groups.includes("Admin")) navigate("/home", { replace: true })

    setIsChecking(false)
  }, [groups, navigate, username])

  if (isChecking) return <div className="flex h-screen w-screen items-center justify-center" />

  return <Outlet />
}
